// Auto-generate optimal connections between sections
export function generateOptimalConnections(sections) {
  if (!sections || sections.length < 2) return [];

  const connections = [];
  
  // Calculate distance between section endpoints
  const getDistance = (x1, y1, x2, y2) => {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  };

  // Get all possible connection points for each section
  const getSectionPoints = (section) => ({
    id: section.id,
    name: section.name,
    start: { x: section.start_x, y: section.start_y },
    end: { x: section.end_x, y: section.end_y }
  });

  const sectionPoints = sections.map(getSectionPoints);
  
  // Use a greedy algorithm to find nearest neighbors
  const connected = new Set();
  const startSection = sectionPoints[0];
  connected.add(startSection.id);
  
  while (connected.size < sectionPoints.length) {
    let minDistance = Infinity;
    let bestConnection = null;
    
    // For each connected section, find the nearest unconnected section
    for (const connectedId of connected) {
      const connectedSection = sectionPoints.find(s => s.id === connectedId);
      
      for (const targetSection of sectionPoints) {
        if (connected.has(targetSection.id)) continue;
        
        // Check all four possible connection combinations
        const distances = [
          { from: connectedSection.id, to: targetSection.id, dist: getDistance(connectedSection.end.x, connectedSection.end.y, targetSection.start.x, targetSection.start.y), fromPoint: 'end', toPoint: 'start' },
          { from: connectedSection.id, to: targetSection.id, dist: getDistance(connectedSection.end.x, connectedSection.end.y, targetSection.end.x, targetSection.end.y), fromPoint: 'end', toPoint: 'end' },
          { from: connectedSection.id, to: targetSection.id, dist: getDistance(connectedSection.start.x, connectedSection.start.y, targetSection.start.x, targetSection.start.y), fromPoint: 'start', toPoint: 'start' },
          { from: connectedSection.id, to: targetSection.id, dist: getDistance(connectedSection.start.x, connectedSection.start.y, targetSection.end.x, targetSection.end.y), fromPoint: 'start', toPoint: 'end' }
        ];
        
        const shortest = distances.reduce((min, curr) => curr.dist < min.dist ? curr : min);
        
        if (shortest.dist < minDistance) {
          minDistance = shortest.dist;
          bestConnection = {
            from_section: shortest.from,
            to_section: shortest.to,
            length_feet: Math.ceil(minDistance / 10), // Assuming ~10 pixels per foot, adjust as needed
            type: 'extension'
          };
        }
      }
    }
    
    if (bestConnection) {
      connections.push({
        ...bestConnection,
        id: `jump-${Date.now()}-${connected.size}`
      });
      connected.add(bestConnection.to_section);
    } else {
      break; // No more connections possible
    }
  }
  
  return connections;
}
